/**
 * ⑧ 洞察摘要卡（标题 + 要点列表）。 Figma：94542:224040
 */

import { SignalCardShell } from "./SignalCardShell";
import type { SignalCardAssetProps } from "./types";

export interface AssetInsightSummaryCardProps extends SignalCardAssetProps {
  title: string;
  bullets: string[];
}

export const AssetInsightSummaryCard: React.FC<
  AssetInsightSummaryCardProps
> = ({ title, bullets, ...asset }) => {
  return (
    <SignalCardShell {...asset}>
      <div className="flex w-full flex-col gap-1">
        <p className="body_medium_m truncate text-content_primary">{title}</p>
        <ul className="flex w-full flex-col gap-1">
          {bullets.map((bullet, index) => (
            <li key={index} className="flex w-full items-start gap-2">
              <span
                aria-hidden
                className="mt-2 size-1 shrink-0 rounded-full bg-content_accent1_primary"
              />
              <p className="body_m min-w-0 flex-1 text-content_secondary">
                {bullet}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </SignalCardShell>
  );
};
